import * as React from 'react'
import {
  getCurrentAssetDrag,
  subscribeAssetDrag,
} from '@repo/studio-components-asset-drag/current-drag'
import { dragDepthAfter, mediaDragIsAvailable } from '../asset-drag/media-drag-presence'

export function useAidaMediaDragAvailable() {
  const asset = React.useSyncExternalStore(subscribeAssetDrag, getCurrentAssetDrag, () => null)
  const [depth, setDepth] = React.useState(0)

  React.useEffect(() => {
    function onEnter() {
      setDepth(current => dragDepthAfter(current, 'enter'))
    }
    function onLeave() {
      setDepth(current => dragDepthAfter(current, 'leave'))
    }
    function onReset() {
      setDepth(current => dragDepthAfter(current, 'reset'))
    }
    document.addEventListener('dragenter', onEnter)
    document.addEventListener('dragleave', onLeave)
    document.addEventListener('drop', onReset)
    document.addEventListener('dragend', onReset)
    return () => {
      document.removeEventListener('dragenter', onEnter)
      document.removeEventListener('dragleave', onLeave)
      document.removeEventListener('drop', onReset)
      document.removeEventListener('dragend', onReset)
    }
  }, [])

  return mediaDragIsAvailable(depth, asset)
}
